import React, { useCallback, useState } from 'react'
import { Link } from 'react-router-dom'
import { FaBars, FaTimes } from 'react-icons/fa'
import { AiFillCaretDown } from "react-icons/ai";
import './NavbarStyles.css'
import { useEffect } from 'react';

import logoToss from '../../assets/logo_toss_blanc.png'
import { useTranslation } from "react-i18next";

import FranceFlag from '../../assets/flag/france.png'
import EnglishFlag from '../../assets/flag/english.png'



const Navbar = (props) => {

  //Lang
  const { t, i18n } = useTranslation('common');

  // Scroll
  const [show, setShow] = useState(false);
  const [lastScrollY, setLastScrollY] = useState(0);

  if (props.color === null) {
    props.color = 'black'
  }

  const controlNavbar = useCallback(() => {
    if (typeof window !== 'undefined') {
      if ((window.scrollY > lastScrollY) && (window.scrollY > '500')) { // if scroll down hide the navbar
        setShow(true);
      } else { // if scroll up show the navbar
        setShow(false);
      }

      // remember current page location to use in the next move
      setLastScrollY(window.scrollY);
    }
  }, [lastScrollY]);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.addEventListener('scroll', controlNavbar);

      // cleanup function
      return () => {
        window.removeEventListener('scroll', controlNavbar);
      };
    }
  }, [controlNavbar]);


  const [click, setClick] = useState(false)
  const handleClick = () => setClick(!click)

  const [clickToss, setClickToss] = useState(true)
  const handleClickToss = () => {
    setClickToss(!clickToss)
    setClickPart(true)
    setClickInfo(true)
    setClickLan(true)
  }

  const [clickPart, setClickPart] = useState(true)
  const handleClickPart = () => {
    setClickPart(!clickPart)
    setClickToss(true)
    setClickInfo(true)
    setClickLan(true)
  }

  const [clickInfo, setClickInfo] = useState(true)
  const handleClickInfo = () => {
    setClickInfo(!clickInfo)
    setClickToss(true)
    setClickPart(true)
    setClickLan(true)
  }


  const [clickLan, setClickLan] = useState(true)
  const handleClickLan = () => {
    setClickLan(!clickLan)
    setClickToss(true)
    setClickPart(true)
    setClickInfo(true)
  }



  const lang = localStorage.getItem('lang')
  const [imgLang, setImgLang] = useState();

  useEffect(() => {
    if (lang === 'FR') {
      setImgLang(FranceFlag)
    }
    if (lang === 'EN') {
      setImgLang(EnglishFlag)
    }
  }, [lang])

  const [color, setColor] = useState(false)
  const changeColor = () => {
    if (window.scrollY >= '500') {
      setColor(true)
    } else {
      setColor(false)
    }
  }

  const changeLang = (lang) => {
    if (lang === 'fr') {
      i18n.changeLanguage('fr')
      localStorage.setItem('lang', 'FR')
      window.location.reload(false);
    }
    if (lang === 'en') {

      i18n.changeLanguage('en')
      localStorage.setItem('lang', 'EN')

      window.location.reload(false);

    }

  }

  useEffect(() => {
    window.addEventListener('scroll', changeColor)
    return () => {
      window.removeEventListener('scroll', changeColor)
    }
  }, [])

  return (
    <nav className={`active ${show && 'hidden'}`}>
      <div className={props.scroll === 'true' ? `header` : (color ? 'header header-bg' : 'header')} style={{ background: color && props.scroll === false ? 'transparent' : props.color }}>
        <Link to='/'><img  src={logoToss} className='logo-toss' alt=""></img></Link>
        <ul className={click ? 'nav-menu active' : 'nav-menu'}>
          <li>
            <button type='button' onClick={handleClickToss} className={clickToss ? '' : 'background-navbar'}>{t('navbar.first')} <AiFillCaretDown /> </button>
            <div className={clickToss ? 'dropdown' : 'dropdown on'}>
              <ul>
                <li> <Link to='/editorial'>Editorial</Link> </li>
                <li> <Link to='/editions'>{t('navbar.edition')}</Link> </li>
                <li> <Link to='/presentation'>{t('navbar.first1')}</Link></li>
                <li> <Link to='/sports'>{t('navbar.first2')}</Link></li>
                <li> <Link to='/galerie'>{t('navbar.first3')}</Link></li>
              </ul>
            </div>
          </li>

          <li>
            <button type='button' onClick={handleClickInfo} className={clickInfo ? '' : 'background-navbar'}>{t('navbar.second')} <AiFillCaretDown /></button>
            <div className={clickInfo ? 'dropdown' : 'dropdown on'}>
              <ul>
                <li> <Link to='/tarif'>{t('navbar.second1')}</Link></li>
                <li> <Link to='/faq'>F.A.Q</Link></li>
                <li> <Link to='/accesTournoi'>{t('navbar.second2')}</Link></li>
                <li>  <Link to='/contacts'>{t('navbar.second3')}</Link></li>
                <li> <Link to='/bracelets'>{t('navbar.second4')}</Link></li>
              </ul>
            </div>
          </li>
          <li>
            <button type='button' onClick={handleClickPart} className={clickPart ? '' : 'background-navbar'}>{t('navbar.third')} <AiFillCaretDown /></button>
            <div className={clickPart ? 'dropdown' : 'dropdown on'}>
              <ul>
                <li><Link to='/mazars'>{t('navbar.third1')} </Link></li>
                <li> <Link to='/partenaireToss'>{t('navbar.third')} </Link></li>
                <li> <Link to='/devenirPart'>{t('navbar.third2')} </Link></li>
                <li> <Link to='/assoPart'>{t('navbar.third3')} </Link></li>
              </ul>
            </div>
          </li>

          <li>
            <Link to='/engagements'>{t('navbar.fourth')} </Link>
          </li>
          <li>
            <Link to='/participer'>{t('navbar.fith')} </Link>
          </li>
          <li>

            <a href='https://toss-register.bds-cs.fr' target='_blank' rel="noreferrer">{t('navbar.six')} </a>

          </li>
          <li >
            <button type='button' onClick={handleClickLan} className={clickLan ? '' : 'background-navbar'}><img  src={imgLang} className='flag' alt="" />{lang} <AiFillCaretDown /></button>
            <div className={clickLan ? 'dropdown lang' : 'dropdown lang on'}  >
              <ul>
                <li>      <button type='button' onClick={() => changeLang('fr')}><img  className='flag' src={FranceFlag} alt="" />FR</button></li>
                <li>      <button type='button' onClick={() => changeLang('en')}><img  className='flag' src={EnglishFlag} alt="" />EN</button></li>



              </ul>
            </div>
          </li>
        </ul>

        <div className='hamburger' onClick={handleClick}>
          {click ? (<FaTimes size={20} style={{ color: '#fff' }} />) : (<FaBars size={20} style={{ color: '#fff' }} />)}

        </div>
      </div>
    </nav>
  )
}

Navbar.defaultProps = {
  scroll: 'true',
  color: 'black'
};
export default Navbar